





























































import { Component, Vue, Ref } from "vue-property-decorator";
import { QDialog } from "quasar";
import { supportRequest } from "@/services";
import { notifyError, notifySuccess } from "@/common/notify";

@Component
export default class HelpDialog extends Vue {
  @Ref("help-dialog")
  dialog!: QDialog;

  private formData = {
    subject: "",
    message: "",
  };

  success = false;
  submit = false;
  loading = false;

  async onSubmit() {
    this.submit = true;
    this.loading = true;
    try {
      await supportRequest(this.formData);
      this.success = true;
      notifySuccess("Richiesta inviata con successo!");
      this.hide();
    } catch (error) {
      this.success = false;
      notifyError("Non è stato possibile inviare la richiesta, riprova più tardi!");
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  onCancelButton() {
    this.$emit("ok");
    this.hide();
  }

  onCancel() {
    this.$emit("cancel");
    this.hide();
  }

  show() {
    this.dialog.show();
  }

  hide() {
    this.dialog.hide();
  }

  onCancelClick() {
    this.hide();
  }

  onDismissClick() {
    this.hide();
  }

  onDialogHide() {
    this.$emit("hide");
  }
}
